import React from 'react';
import logoSvg from './logo.svg';
import logoMini from './logo-mini.svg';
import logoMiniNoBG from './logo-mini-nobg.svg';
import PropTypes from 'prop-types';

const Logo = ({ className, type }) => {
    const choseType = () => {
        switch (type) {
            case 'mini':
                return logoMini;
            case 'mini-nobg':
                return logoMiniNoBG;
            default:
                return logoSvg;
        }
    };

    return <img className={className} xmlns="http://www.w3.org/2000/svg" alt={'Tex-Color'} src={choseType()} />;
};

Logo.propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(['mini', 'mini-nobg']),
};

export default Logo;
